module.exports = __webpack_public_path__ + "img/kbank.33ec99e6.png";